import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-singnature-pad-pop-up',
  templateUrl: './singnature-pad-pop-up.component.html',
  styleUrls: ['./singnature-pad-pop-up.component.css']
})
export class SingnaturePadPopUpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
